import {
  getMedicalDeviceInfoUrlUsecase,
  getPrivacyPolicyUrlUsecase,
  getTermsOfServiceUrlUsecase,
} from "@/init/initializeInstances";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import LanguageSelector from "../language-selector/language-selector";
import { useFooterViewModel } from "./footer-view-model";
import styles from "./footer-view.module.css";

export default function Footer() {
  const vm = useFooterViewModel({
    getMedicalDeviceInfoUrlUsecase,
    getPrivacyPolicyUrlUsecase,
    getTermsOfServiceUrlUsecase,
  });

  const { t } = useTranslation();

  //MARK:- Early return for excluded paths
  if (vm.isExcluded) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <LanguageSelector />
        <div style={{ flex: 1 }} />
        <div className={styles.fotterLinkContainter}>
          <Link to={vm.medicalDeviceInfoPath} className={styles.fotterText}>
            {t("footer.medical.device.info")}
          </Link>
          <Link
            to={vm.termsOfServiceUrl}
            target="_blank"
            className={styles.fotterText}
            rel="noopener noreferrer"
          >
            {t("footer.terms")}
          </Link>
          <Link
            to={vm.privacyPolicyUrl}
            target="_blank"
            className={styles.fotterText}
            rel="noopener noreferrer"
          >
            {t("footer.privacy")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
